import { AccountProps } from 'components/shared/AccountConnector';
import React from 'react';
import { setShouldPresentMarketModalOnLS } from '../MarketSelectorModal';
import { useObservability } from 'helpers/observability';

export function usePromptGoogleOneTap(
  account: Pick<AccountProps, 'infoIsLoading' | 'loggedIn' | 'register'>,
  source: 'gallery' | 'pdp' | 'login' | 'homepage',
  { disablePromptGoogleOneTap }: { disablePromptGoogleOneTap?: boolean } = {},
) {
  const { trackEvent, trackError } = useObservability();

  const isAuthenticatedOrLoadingOrDisabled =
    account.infoIsLoading || account.loggedIn || disablePromptGoogleOneTap;
  React.useEffect(() => {
    if (!isAuthenticatedOrLoadingOrDisabled) {
      import('components/shared/GoogleOneTap').then(({ promptGoogleOneTap }) => {
        promptGoogleOneTap(
          `cosmos-exclusive-${source}`,
          (...args) => {
            setShouldPresentMarketModalOnLS(true);
            account.register(...args);
          },
          trackEvent,
          trackError,
        );
      });
    }
  }, [isAuthenticatedOrLoadingOrDisabled]);
}
